import React, { useContext, useEffect, useState, useRef } from 'react';
import { IProps } from './types';
import * as S from './styles';
import { Context } from "routes/private/Editor/Context";
import ToggleSwitch from '@components/ToggleSwitch';
import { GearIcon } from '@assets/icons/gearIcon';
import { useSelector, useDispatch } from 'react-redux';
import selectors from '@state/selectors';
import actions from '@state/actions';
import {IUserConfigState, IUserConfig} from '@state/userConfig/types';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { cloneDeep } from 'lodash';
const uuid = require('react-uuid');

const UserPreferences: React.FC<IProps> = (props) => {
  const context = useContext(Context);
  const [open, setOpen] = useState(false);
  const userConfig: IUserConfig|undefined = useSelector(selectors.userConfig.getUserConfig);
  const authContext = useContext(AuthContext);
  const dispatch = useDispatch();

  const addUserconfig = (userconfig:IUserConfig ) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.userConfig.addUserConfig(userconfig,(result, error) => {
        if (error) reject(error);
        else resolve(result);
      }))
    });
  }

  const updateUserconfig = (userconfig:IUserConfig ) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.userConfig.updateUserConfig(userconfig,(result, error) => {
        if (error) reject(error);
        else resolve(result);
      }))
    });
  }

  const useOutsideAlerter = (ref:any) => {
    useEffect(() => {
      const handleClickOutside = (event:any) => {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  const handleOpen = () => {
    setOpen(!open);
  }

  const handleToggle = async(type: string, value: boolean) => {
    let newUserconfig:IUserConfig|undefined = cloneDeep(userConfig);
    let add: boolean = false;

    if (newUserconfig===undefined || newUserconfig.id===null) {
      newUserconfig = {
        id: uuid(), 
        entityType:"", 
        user: {
          email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
          name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
        }
      }
      add = true;
    }
    if (newUserconfig.multiEditor===undefined)  newUserconfig.multiEditor = { showColors: false, showFonts:false} 
    if (type==="color") newUserconfig.multiEditor.showColors = value;
    if (type==="font") newUserconfig.multiEditor.showFonts = value;
    
    if (add) await addUserconfig(newUserconfig);
    else await updateUserconfig(newUserconfig);
  }
  
  return (
    <S.Root
      ref={wrapperRef}
    >
      <S.IconContainer
        onClick={handleOpen}
        openValue={open}
      >
        <GearIcon
        />
      </S.IconContainer>
      {
        open &&
        <S.Container>
          <S.Title>
          View Color and Font in MultiEditor
          </S.Title>
          <S.SubTitle>
            Color
          </S.SubTitle>
          <S.SwitchContainer>
            Off
            <S.SwitchPadding>
              <ToggleSwitch
                id="checkbox-color"
                onChange={() => handleToggle('color', userConfig?.multiEditor?.showColors ? false: true)} 
                checked={!userConfig?.multiEditor?.showColors ? false: true} style={{ display: "inline-block" }}
                activeStyle={true}
              />
            </S.SwitchPadding>
            On
          </S.SwitchContainer>
          <S.SubTitle>
            Font
          </S.SubTitle>
          <S.SwitchContainer>
            Off
            <S.SwitchPadding>
              <ToggleSwitch
                id="checkbox-font"
                onChange={() => handleToggle('font', userConfig?.multiEditor?.showFonts ? false: true)} 
                checked={!userConfig?.multiEditor?.showFonts ? false: true} style={{ display: "inline-block" }}
                activeStyle={true}
              />
            </S.SwitchPadding>
            On
          </S.SwitchContainer>
        </S.Container>
      }
    </S.Root>
  );
}

export default UserPreferences;